const features = [
  { icon: 'ri-4k-line', title: '超清画质', desc: '支持多档清晰度选择，最高可达4K超清，享受极致观影体验' },
  { icon: 'ri-speed-up-line', title: '极速加载', desc: '智能CDN加速技术，秒开视频无需等待，高清视频不缓冲' },
  { icon: 'ri-smartphone-line', title: '全端适配', desc: '完美适配PC、平板、手机端，随时随地畅享91免费视频' },
  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '严格内容审核机制，纯净观影环境，无弹窗无恶意广告' },
  { icon: 'ri-refresh-line', title: '每日更新', desc: '内容团队每日精选更新，保证资源库持续丰富，新鲜内容不断档' },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100/80 text-primary-700 text-xs font-label font-semibold mb-4 whitespace-nowrap">
            平台优势
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            为什么选择我们
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            五大核心优势打造优质免费视频平台
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {features.map((feat) => (
            <div
              key={feat.title}
              className="p-5 rounded-xl bg-background-100 border border-background-200/60 text-center hover:border-primary-200 transition-colors group cursor-pointer"
            >
              <span className="w-12 h-12 flex items-center justify-center mx-auto mb-3 rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${feat.icon} text-primary-600 text-xl`}></i>
              </span>
              <h3 className="font-heading font-semibold text-sm text-foreground-900 mb-2">{feat.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{feat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}